import { 
    Component, 
    OnInit, 
    ViewChild 
} from '@angular/core';
declare var jquery: any;
declare var $: any;
import 'datatables.net';
import { GridOptions } from "ag-grid/main";
import { Globals } from '../../globals';
// import { setTimeout } from 'timers';
import { isNull, isUndefined } from 'util';
import { CoachService, CoachClientDto } from 'app/services/coach/CoachService';
import { Router } from '@angular/router';
import { PurchaseAssessmentModalComponent } from '../../purchase-assessment-modal/purchase-assessment-modal.component';
import { AssignAssessmentModalComponent } from '../../assign-assessment-modal/assign-assessment-modal.component';
import { ActiveClientsComponent } from '../active-clients/active-clients.component';
import { ArchivedClientsComponent } from '../archived-clients/archived-clients.component';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from '../../services/admin/AdminService';


@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss']
})
export class ClientsComponent implements OnInit {
    modalIndex: number;

    @ViewChild('purchaseAssessment', { static: true }) public purchaseAssessmentModal: PurchaseAssessmentModalComponent;
    @ViewChild('assignAssessment', { static: true }) public assignAssessmentModal: AssignAssessmentModalComponent;
    @ViewChild('activeClients', { static: true }) public activeClientsComponent: ActiveClientsComponent;
    @ViewChild('archivedClients', { static: true }) public archivedClientsComponent: ArchivedClientsComponent;

    showActiveClientTable: boolean = false;
    showArchiveClientTable: boolean = false;
    clientsHeaders: any[];
    gridOptions: GridOptions;
    height: number;
    count: number;
    rowSelection: any;
    enableFilter: boolean = false;
    filters = [
        {
            "text": "Contains",
            "value": "contains"
        },
        {
            "text": "Equals",
            "value": "equals"
        },
        {
            "text": "Not Equals",
            "value": "notEquals"
        },
        {
            "text": "Starts With",
            "value":"startsWith"
        },
        {
            "text": "Ends With",
            "value":"endsWith"
        },
        {
            "text": "Not Contain",
            "value": "notContain"
        },
        {
            "text": "Not Start With",
            "value": "notStartWith"
        }
    ];
    assessmentsELIData: any[] = [];
    assessments360Data: any[] = [];
    assessmentsRegularGridApi: any;
    assessments360GridApi: any;
    assessmentsHeaders: any[] = [];
    selectedAssessment: any[] = [];
    assessmentsGridOptions: GridOptions;
    currentAssessmentTypeSelected: number;
    pageName: string = "clients";
    okImportClientsButton: string = "Ok";
    currentTab = 1;

    constructor(
        private _AdminService: AdminService,
        public _Globals: Globals,
        private router: Router,
        private _toastr: ToastrService,
    ) {
        this.rowSelection = "multiple";
    }

    ngOnInit() {
        this.gridOptions = {};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;
        this.assessmentsGridOptions = {};
        this.assessmentsGridOptions.rowHeight = 45;
        this.assessmentsGridOptions.headerHeight = 40;

        this.clientsHeaders = this.createHeaders();
        this.assessmentsHeaders = this.createAssessmentsHeaders()

    }

    onShowActiveClientTableChange(value: boolean): void {
        this.showActiveClientTable = value;
    }

    onShowArchiveClientTableChange(value: boolean): void {
        this.showArchiveClientTable = value;
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    createHeaders() {
        let columnDefs = new Array();

        let emailHeader = {
            headerName: 'Email',
            field: 'Email',
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            filterParams: {
                apply: true
            },
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(emailHeader);

        let nameHeader = {
            headerName: 'First Name',
            field: 'FirstName',
            filterParams: {
                suppressAndOrCondition: true,
                apply: true
            },
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        let lastNameHeader = {
            headerName: 'Last Name',
            field: 'LastName',
            filterParams: {
                apply: true
            },
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(lastNameHeader);

        let statusHeader = {
            headerName: 'Status',
            field: 'Status',
            filterParams: {
                apply: true
            },
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(statusHeader);

        let assessmentStatusHeader = {
            headerName: 'Assessment Status',
            field: 'AssessmentStatus',
            filterParams: {
                apply: true
            },
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(assessmentStatusHeader);

        return columnDefs;
    }

    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;

            this.router.navigate(['/app/edit_clients', data['ClientId'], data["Email"], data["FirstName"], data["LastName"], data["Status"]]);
        }
    }

    edit(id: number, text: string) {
        console.log('edit');
    }

    closeModal() {
        $('#caddClientModal').modal('hide');
        $('#cname').val('');
        $('#clast').val('');
    }

    preventLetters(event: any) {
        if (event.which < 48 || event.which > 57) {
            event.preventDefault();
            console.log('');
        }
    }

    tabSelect(event: any) {
        if (event === this.currentTab)
        {
            return;
        }

        console.log('tabSelect');
        console.log(event);

        switch (event) {

            case 1: {
                $(".editClientTabs .tab-pane").removeClass('active in');
                $(".editClientTabs .tab-pane").eq(0).addClass('active in');
                this.activeClientsComponent.showTable = false;
                if (this.activeClientsComponent.getDisplayingTagsCount() > 0) {
                    this.activeClientsComponent.getCoachClientsFilteringByTag();
                } else {
                    this.activeClientsComponent.GetCoachClients();
                }
                this.activeClientsComponent.deselectAllCheckBox(this.activeClientsComponent.gridApi);
                this.currentTab = 1;
                break;
            }

            case 2: {
                $(".editClientTabs .tab-pane").removeClass('active in');
                $(".editClientTabs .tab-pane").eq(1).addClass('active in');
                this.archivedClientsComponent.showTable = false;
                this.archivedClientsComponent.GetArchiveCoachClients();
                this.archivedClientsComponent.deselectAllCheckBox(this.archivedClientsComponent.gridApi)
                this.currentTab = 2;
                break;
            }
        }

    }

    openTab(menu: string) {
        var res = menu.split("-");
        console.log('currentSelectedTab', res[0]);
        console.log('tab', res[1]);

        this.tabSelect(parseInt(res[0]));
    }

    filterModified(e) {
        console.log(e.api.filterManager.allFilters);
    }


    //----QUICK MENU-----

    /*Purchase Modal*/
    openPurchaseModal() {
        //this._Globals.purchaseFromHome = true;
        this.purchaseAssessmentModal.show(this);
    }

    /*Assign Modal*/
    openAssignModal() {
        this.assignAssessmentModal.selectedAssessment = [];
        this.assignAssessmentModal.showAssignModal(this, 1);
    }

    onOpenAssignModal(data: any): void {
        this.assignAssessmentModal.assignAssessmentNewModal.show(
            data.context,
            false,
            data.is360,
            data.amount,
            data.assessmentName,
            data.assessmentId,
            undefined);
    }

    assignOnGridReady(grid, params) {
        if (grid === 1) {
            this.assessmentsRegularGridApi = params.api;
        } else {
            this.assessments360GridApi = params.api;
        }
    }

    onAssessessmentRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
        }
    }

    createAssessmentsHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'AssessmentName',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        let quantityHeader = {
            headerName: 'Quantity',
            field: 'Amount',
            minWidth: 120,
            width: 120,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(quantityHeader);

        return columnDefs;
    }

    // onAssessmentsSelectionChanged(grid, event) {

    //     console.log("onSelectionChanged ", event);

    //     var rowCount = event.api.getSelectedNodes().length;
    //     console.log("selection changed, ", rowCount + " rows selected");

    //     if (grid === 1) {
    //         this.selectedAssessment = this.activeClientsComponent.getSelectedRows(this.assessmentsRegularGridApi);
    //     } else {
    //         this.selectedAssessment = this.activeClientsComponent.getSelectedRows(this.assessments360GridApi);
    //     }

    //     console.log("selected Assessment", this.selectedAssessment);
    // }

    getUserPersonalData() {
        $('body').css('cursor', 'wait');

        this._AdminService.getUserPersonalData(this._Globals.getUserId()).subscribe((data: any) => {
            console.log('response_getUserPersonalData', data);
            $('body').css('cursor', 'default');

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                $("input[name='first_name']").val(_data.vg6);
                $("input[name='last_name']").val(_data.hj7);
                $("input[name='user_email']").val(_data.sr3);
                $("input[name='contact_id']").val(_data.by3);

                if (_data.by3 != "0") {
                    this.ssoToShopify();
                }
                else {
                    this._toastr.warning('You are not authorized to access the requested page', "ELI");
                }
            }
        })
    }

    ssoToShopify() {

        var shopifyForm: any = document.getElementById('shopifyForm');
        shopifyForm.submit();
    }

}
